// extracted by mini-css-extract-plugin
module.exports = {"grid":"br_bk","column":"br_g0","link":"br_cn","title":"br_p","description":"br_h","darkMode":"br_cN"};